module.exports = __webpack_public_path__ + "img/maps.85f72cd5.svg";